var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.637,
    height: 24.012,
    viewBox: "0 0 24.637 24.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-left-arrow",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-left-solid",
    d: "M14.111,60.054l-1.221,1.221a1.314,1.314,0,0,1-1.864,0L.338,50.591a1.314,1.314,0,0,1,0-1.864L11.027,38.038a1.314,1.314,0,0,1,1.864,0l1.221,1.221a1.321,1.321,0,0,1-.022,1.886L7.464,47.457h15.8a1.316,1.316,0,0,1,1.32,1.32v1.76a1.316,1.316,0,0,1-1.32,1.32H7.464l6.626,6.312A1.312,1.312,0,0,1,14.111,60.054Z",
    transform: "translate(0.051 -37.65)",
    fill: "#146f62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeftArrow);
export default __webpack_public_path__ + "static/media/ic_left_arrow.37ba55cdaa4d63ecff4b46f1f56b3d64.svg";
export { ForwardRef as ReactComponent };